<template>
  <div class="steps">
    <div class="dir"></div>
    <div
      class="step"
      :class="stepCls(1)">
      <i
        v-if="this.index >= 1"
        class="iconfont">&#xe6da;</i>
      <i
        v-else
        class="iconfont"
        :class="{active: this.index< 1}">1</i>
      <span>{{ value[0] }}</span>
    </div>
    <div
      class="step"
      :class="stepCls(2)">
      <i
        v-if="this.index >= 2"
        class="iconfont">&#xe6da;</i>
      <i
        v-else
        class="iconfont"
        :class="{active: this.index< 2}">2</i>
      <span>{{ value[1] }}</span>
    </div>
    <div
      v-if="visible"
      class="step"
      :class="stepCls(3)">
      <i
        v-if="this.index >= 3"
        class="iconfont">&#xe6da;</i>
      <i
        v-else
        class="iconfont"
        :class="{active: this.index< 3}">3</i>
      <span>{{ value[2] }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      default: 1,
    },
    value: {
      type: Array,
      default: () => ['身份验证', '修改登录手机号码', '完成'],
    },
    visible: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    stepCls(start) {
      return this.index >= start ? `active` : ``;
    },
    stepContent(n) {
      return this.index === n ? `&#xe6da;` : n;
    },
  },
};
</script>

<style lang="scss" scoped>
.steps {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 470px;
  margin: 75px auto;
  .dir {
    position: absolute;
    top: 20px;
    left: 60px;
    width: 358px;
    height: 1px;
    border-top: 2px dotted rgba(0, 0, 0, 0.09);
  }
  .step {
    position: relative;
    flex: 0 auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    i {
      width: 40px;
      height: 40px;
      border-radius: 40px;
      margin-bottom: 9px;
      background: rgba(207, 207, 207, 1);
      color: #fff;
      line-height: 40px;
      text-align: center;
      &.active {
        font-family: pingfang-medium, "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif !important;
      }
    }
    span {
      color: rgba(0, 0, 0, 0.65);
    }
    &.active {
      i {
        background: rgba(24, 144, 255, 1);
      }
      span {
        color: rgba(24, 144, 255, 1);
      }
    }
  }
}
</style>
